<template>
  <div class="zy-health rescue-page">
    <!-- 顶部导航栏 -->
    <header class="rescue-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: (statusBarHeight + 12) + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">一键救援</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="rescue-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 紧急信息横幅 -->
      <div class="rescue-banner">
        <div class="banner-text">
          <div class="banner-line1">中国公民突发重病、</div>
          <div class="banner-line2">突发重伤特别救援通道。</div>
        </div>
        <div class="banner-arrow"></div>
      </div>

      <!-- 用户和位置信息 -->
      <div class="rescue-user-info">
        <div class="user-info-left">
          <div class="app-icon-wrapper">
            <div class="app-icon">
              <img src="@/assets/login/Headicon.png" alt="大救星" class="app-icon-img" />
            </div>
            <!-- <div class="app-version">健康版</div> -->
          </div>
        </div>
        <div class="user-info-right">
          <div class="user-phone">用户{{ maskedPhone }}</div>
          <div class="location-info">
            <span class="location-text">位置:{{ baiduAddress }}</span>
            <i class="el-icon-location location-icon"></i>
          </div>
          <!-- <div v-if="baiduLocation" class="location-detail"> -->
            <!-- <div class="location-detail-row">
              <span class="detail-label">经纬度：</span>
              <span class="detail-value">{{ baiduLocation.lng }}, {{ baiduLocation.lat }}</span>
            </div> -->
            <!-- <div v-if="baiduAddress" class="location-detail-row">
              <span class="detail-label">地址：</span>
              <span class="detail-value">{{ baiduAddress }}</span>
            </div> -->
          <!-- </div> -->
        </div>
      </div>

      <!-- 倒计时区域 -->
      <div class="rescue-countdown">
        <div v-if="showPreCountdown" class="pre-countdown-text">
          <span class="pre-countdown-number">{{ preCountdown }}</span>秒后将开启倒计时
        </div>
        <div v-if="showMainCountdown" class="main-countdown">
          <div class="countdown-number">{{ countdown }}</div>
          <div class="countdown-unit">秒</div>
        </div>
      </div>

      <!-- 说明文字 -->
      <div class="rescue-disclaimer">
        倒计时结束后,大救星将为您启动一键救援服务。请您提供真实有效的救助信息,否则将影响求助效果并承担法律责任。
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { useUserStore } from '@/stores/user';
import { findAddress, submitRescue } from '@/api/activity';
// import { findAddress } from '@/api/activity';

export default {
  name: 'Rescue',
  data() {
    return {
      preCountdown: 1, // 预倒计时（1秒）
      countdown: 5, // 主倒计时（5秒）
      showPreCountdown: true,
      showMainCountdown: false,
      preCountdownTimer: null,
      countdownTimer: null,
      locationText: '正在获得您的位置信息......',
      locationTimer: null,
      currentLocation: null, // 当前位置信息
      marsLocation: null, // 火星坐标
      baiduLocation: null, // 百度定位点（GCJ02）
      baiduAddress: '正在获取中...' // 百度逆地理解析详细地址
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    ...mapState(useUserStore, ['userInfo']),
    /**
     * 获取脱敏后的手机号
     */
    maskedPhone() {
      const phone = this.userInfo.userPhone || this.userInfo.phone || '';
      if (phone && phone.length >= 11) {
        return phone.substring(0, 3) + '****' + phone.substring(7);
      }
      return phone || '***';
    }
  },
  mounted() {
    // 设置页面背景色
    document.body.style.backgroundColor = '#F2F3F5';
    
    // 开始预倒计时
    this.startPreCountdown();
    
    // 开始获取位置信息
    this.startLocationFetch();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.preCountdownTimer) {
      clearInterval(this.preCountdownTimer);
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.locationTimer) {
      clearTimeout(this.locationTimer);
    }
    
    // 恢复页面背景色
    document.body.style.backgroundColor = '';
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 开始预倒计时（1秒）
     */
    startPreCountdown() {
      this.preCountdownTimer = setInterval(() => {
        this.preCountdown--;
        if (this.preCountdown <= 0) {
          clearInterval(this.preCountdownTimer);
          this.showPreCountdown = false;
          this.showMainCountdown = true;
          // 开始主倒计时
          this.startMainCountdown();
        }
      }, 1000);
    },
    /**
     * 开始主倒计时（5秒）
     */
    startMainCountdown() {
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          // 倒计时结束，触发救援服务
          this.triggerRescue();
        }
      }, 1000);
    },
    /**
     * 触发救援服务
     */
    async triggerRescue() {
      console.log('倒计时结束，启动一键救援服务');
      
      // 检查是否有位置信息
      if (!this.baiduLocation || !this.baiduAddress) {
        this.$message && this.$message.error('位置信息未获取完成，请稍候再试');
        return;
      }
      
      // 检查地址是否有效
      if (this.baiduAddress === '正在获取中...' || this.baiduAddress === '地址解析失败' || !this.baiduAddress.trim()) {
        this.$message && this.$message.error('地址信息不完整，无法提交救援请求');
        return;
      }
      
      try {
        // 构建请求参数
        const rescueData = {
          lat: this.baiduLocation.lat,
          lon: this.baiduLocation.lng,
          address: this.baiduAddress
        };
        
        console.log('提交救援请求:', rescueData);
        
        // 调用提交救援接口
        const response = await submitRescue(rescueData);
        
        if (response && (response.code === '1000' || response.code === 1000)) {
          // 提交成功，跳转到救援处理中页面
          this.$router.replace({ name: 'rescueProcessing' });
        } else {
          // 提交失败
          const errorMsg = response.msg || '提交失败，请重试';
          this.$message && this.$message.error(errorMsg);
          console.error('救援请求提交失败:', response);
        }
      } catch (error) {
        console.error('救援请求提交异常:', error);
        this.$message && this.$message.error('提交失败，请稍候再试');
      }
    },
    /**
     * 开始获取位置信息
     */
    startLocationFetch() {
      // 首先使用HTML5 Geolocation获取WGS84坐标（当前位置）
      console.log('开始获取位置信息',navigator);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // 获取WGS84坐标
            this.currentLocation = {
              lng: position.coords.longitude,
              lat: position.coords.latitude
            };
            
            // 然后使用百度地图定位服务获取GCJ02坐标（火星坐标）
            this.getBaiduLocation();
          },
          (error) => {
            // HTML5 定位在 WebView/非 HTTPS/未授权等场景下失败属于常见情况，直接兜底百度定位即可
            console.warn('HTML5定位失败，已切换百度定位:', error);
            this.locationText = '正在使用百度定位获取...';
            this.getBaiduLocation();
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        );
      } else {
        console.warn('浏览器不支持Geolocation API，已切换百度定位');
        this.locationText = '正在使用百度定位获取...';
        // 直接使用百度地图定位
        this.getBaiduLocation();
      }
    },
    /**
     * 使用百度地图定位服务获取GCJ02坐标（火星坐标）
     */
    getBaiduLocation() {
      // 检查百度地图API是否加载完成
      if (typeof BMap === 'undefined') {
        console.error('百度地图API未加载');
        this.locationText = '获取位置信息失败';
        return;
      }
      
      // 使用百度地图定位服务
      const geolocation = new BMap.Geolocation();
      
      geolocation.getCurrentPosition(
        (result) => {
          const status = geolocation.getStatus();
          // 0 表示成功；其余为失败状态码
          if (status === 0) {
            // 获取火星坐标（GCJ02）
            const point = result.point;
            this.marsLocation = {
              lng: point.lng, // 经度
              lat: point.lat  // 纬度
            };
            this.baiduLocation = { lng: point.lng, lat: point.lat };
            
            // 打印坐标信息
            console.log('========== 位置信息 ==========');
            if (this.currentLocation) {
              console.log('当前位置（WGS84坐标）:');
              console.log('  经度:', this.currentLocation.lng);
              console.log('  纬度:', this.currentLocation.lat);
            }
            console.log('火星坐标（GCJ02坐标）:');
            console.log('  经度:', this.marsLocation.lng);
            console.log('  纬度:', this.marsLocation.lat);

            // 联调后端接口：根据GCJ-02经纬度查询更完整地址
            this.fetchAddressByGcj02(point);

            // 逆地理解析获取详细地址
            const geocoder = new BMap.Geocoder();
            geocoder.getLocation(point, (rs) => {
              if (rs) {
                let address = '';
                
                // 优先从 addressComponents 拼接地址，确保包含街道信息
                if (rs.addressComponents) {
                  const addr = rs.addressComponents;
                  const parts = [];
                  if (addr.province) parts.push(addr.province);
                  if (addr.city) parts.push(addr.city);
                  if (addr.district) parts.push(addr.district);
                  if (addr.street) parts.push(addr.street);
                  if (addr.streetNumber) parts.push(addr.streetNumber);
                  address = parts.join('');
                }
                
                // 如果 addressComponents 拼接失败，使用 address 字段作为兜底
                if (!address && rs.address) {
                  address = rs.address;
                }
                
                this.baiduAddress = address || '地址解析中...';
                
                console.log('详细地址:', address || '(空)');
                console.log('地址组件:', rs.addressComponents);
                console.log('原始address字段:', rs.address);
                console.log('============================');
              } else {
                console.warn('逆地理解析返回数据为空');
                this.baiduAddress = '地址解析失败';
              }

              // 更新位置文本
              this.locationText = '已获取您的位置信息';
            });
          } else {
            /**
             * 百度定位失败常见原因：
             * - 6：无法获取位置/超时（权限、网络、定位源不可用）
             * - 7：服务不可用
             * - 8：鉴权失败（AK 白名单/配额/Referer 配置）
             */
            console.warn('百度地图定位失败，status:', status, 'result:', result);
            this.locationText = `百度定位失败(${status})`;

            // 做一次轻量重试，避免首次加载/权限弹窗导致的瞬时失败
            setTimeout(() => {
              const retry = new BMap.Geolocation();
              retry.getCurrentPosition(
                (retryRes) => {
                  const retryStatus = retry.getStatus();
                  if (retryStatus === 0) {
                    const p = retryRes.point;
                    this.marsLocation = { lng: p.lng, lat: p.lat };
                    this.baiduLocation = { lng: p.lng, lat: p.lat };

                    this.fetchAddressByGcj02(p);

                    const geocoder = new BMap.Geocoder();
                    geocoder.getLocation(p, (rs) => {
                      if (rs) {
                        let address = '';
                        
                        // 优先从 addressComponents 拼接地址，确保包含街道信息
                        if (rs.addressComponents) {
                          const addr = rs.addressComponents;
                          const parts = [];
                          if (addr.province) parts.push(addr.province);
                          if (addr.city) parts.push(addr.city);
                          if (addr.district) parts.push(addr.district);
                          if (addr.street) parts.push(addr.street);
                          if (addr.streetNumber) parts.push(addr.streetNumber);
                          address = parts.join('');
                        }
                        
                        // 如果 addressComponents 拼接失败，使用 address 字段作为兜底
                        if (!address && rs.address) {
                          address = rs.address;
                        }
                        
                        this.baiduAddress = address || '地址解析中...';
                        console.log('百度定位重试成功:', this.baiduLocation, '地址:', address || '(空)');
                        console.log('地址组件:', rs.addressComponents);
                      } else {
                        console.warn('逆地理解析返回数据为空');
                        this.baiduAddress = '地址解析失败';
                      }
                      this.locationText = '已获取您的位置信息';
                    });
                  } else {
                    console.warn('百度地图定位重试失败，status:', retryStatus, 'result:', retryRes);
                    this.locationText = `百度定位失败(${retryStatus})`;
                  }
                },
                { enableHighAccuracy: true }
              );
            }, 800);
          }
        },
        { enableHighAccuracy: true }
      );
    },

    /**
     * 调用后端 findAddress：根据 GCJ-02 经纬度获取详细地址并赋值给 baiduAddress
     * @param {Object} point - 百度定位点（GCJ-02）
     * @param {number} point.lng - 经度（GCJ-02）
     * @param {number} point.lat - 纬度（GCJ-02）
     */
    async fetchAddressByGcj02(point) {
      try {
        const res = await findAddress({
          lat: Number(point.lat),
          lon: Number(point.lng)
        });

        if (res && (res.code === '1000' || res.code === 1000) && res.data && res.data.address) {
          this.baiduAddress = res.data.address;
          console.log('findAddress接口返回地址:', res.data.address);
          console.log('findAddress接口返回坐标(BD-09):', res.data.longitude, res.data.latitude);
        } else {
          console.warn('findAddress接口返回异常:', res);
        }
      } catch (error) {
        console.warn('findAddress接口调用失败:', error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.rescue-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 */
  .rescue-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
    padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
  }

  /* 内容区域 */
  .rescue-content {
    width: 100%;
    padding: 20px 16px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
    box-sizing: border-box;
  }

  /* 紧急信息横幅 */
  .rescue-banner {
    position: relative;
    width: 100%;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
    border-radius: 16px;
    padding: 18px 20px;
    margin-bottom: 24px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.25);
    
    /* 世界地图背景效果 */
    &::before {
      content: '';
      position: absolute;
      top: -20px;
      right: -30px;
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      border-radius: 50%;
      opacity: 0.6;
    }
    
    .banner-text {
      color: #ffffff;
      font-size: 15px;
      line-height: 1.8;
      position: relative;
      z-index: 2;
      font-weight: 400;
      
      .banner-line1 {
        margin-bottom: 6px;
        letter-spacing: 0.5px;
      }
      
      .banner-line2 {
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }
    
    .banner-arrow {
      position: absolute;
      right: -15px;
      top: 50%;
      transform: translateY(-50%) rotate(-45deg);
      width: 80px;
      height: 80px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      opacity: 0.8;
    }
  }

  /* 用户和位置信息 */
  .rescue-user-info {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 16px;
    padding: 18px;
    margin-bottom: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    
    &:active {
      transform: scale(0.98);
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
    }
    
    .user-info-left {
      margin-right: 16px;
      flex-shrink: 0;
      
      .app-icon-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .app-icon {
          width: 64px;
          height: 64px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          position: relative;
          overflow: hidden;
          background: #ffffff;
          
          .app-icon-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
          }
        }
        
        .app-version {
          background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
          color: #333333;
          font-size: 11px;
          padding: 3px 8px;
          border-radius: 6px;
          font-weight: 600;
          box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
          letter-spacing: 0.5px;
        }
      }
    }
    
    .user-info-right {
      flex: 1;
      min-width: 0;
      
      .user-phone {
        font-size: 17px;
        color: #333333;
        margin-bottom: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
      
      .location-info {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        
        .location-text {
          flex: 1;
          min-width: 0;
          word-break: break-all;
        }
        
        .location-icon {
          font-size: 20px;
          color: #4A90E2;
          margin-left: 10px;
          flex-shrink: 0;
          animation: pulse 2s ease-in-out infinite;
        }
      }

      .location-detail {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #F0F0F0;
        display: flex;
        flex-direction: column;
        gap: 6px;

        .location-detail-row {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          font-size: 12px;
          line-height: 1.4;
          color: #666666;
        }

        .detail-label {
          flex-shrink: 0;
          color: #999999;
        }

        .detail-value {
          flex: 1;
          min-width: 0;
          color: #333333;
          word-break: break-all;
        }
      }
    }
  }
  
  /* 位置图标脉冲动画 */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.1);
    }
  }

  /* 倒计时区域 */
  .rescue-countdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    margin-bottom: 32px;
    position: relative;
    
    .pre-countdown-text {
      font-size: 16px;
      color: #4A90E2;
      font-weight: 500;
      margin-bottom: 24px;
      animation: fadeInOut 1s ease-in-out;
      
      .pre-countdown-number {
        color: #FF6B6B;
        font-weight: 700;
        font-size: 18px;
        margin: 0 2px;
      }
    }
    
    .main-countdown {
      display: flex;
      align-items: baseline;
      justify-content: center;
      position: relative;
      
      /* 圆形背景 */
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 180px;
        height: 180px;
        background: linear-gradient(135deg, rgba(46, 92, 138, 0.2) 0%, rgba(46, 92, 138, 0.1) 100%);
        border-radius: 50%;
        z-index: 0;
        animation: ripple 2s ease-out infinite;
      }
      
      .countdown-number {
        font-size: 100px;
        font-weight: 700;
        color: #2E5C8A;
        line-height: 1;
        position: relative;
        z-index: 1;
        text-shadow: 0 2px 8px rgba(46, 92, 138, 0.3);
        animation: countdownPulse 1s ease-in-out infinite;
        font-family: 'Arial', sans-serif;
      }
      
      .countdown-unit {
        font-size: 24px;
        color: #2E5C8A;
        margin-left: 6px;
        font-weight: 500;
        position: relative;
        bottom: 12px;
        z-index: 1;
        opacity: 0.95;
      }
    }
  }
  
  /* 倒计时动画 */
  @keyframes fadeInOut {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
  
  @keyframes countdownPulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  @keyframes ripple {
    0% {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0;
    }
  }

  /* 说明文字 */
  .rescue-disclaimer {
    font-size: 13px;
    color: #666666;
    line-height: 1.8;
    text-align: center;
    padding: 0 24px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    padding: 16px 20px;
    margin: 0 8px;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>





// WEBPACK FOOTER //
// src/views/rescue/index.vue